import { LoadingButton } from '@mui/lab';
import { CSSProperties, MouseEventHandler, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

const AgLoadingButton = (
  {
    loadingIndicator,
    disabled,
    loading,
    startIcon,
    endIcon,
    style,
    onClick, //required
    label, //required
    width,
    variant,
    color,
    size,
    dataTestId,
    type
  }: {
    loadingIndicator?: ReactNode,
    disabled?: boolean,
    loading?: boolean,
    startIcon?: ReactNode,
    endIcon?: ReactNode,
    style?: CSSProperties | undefined,
    onClick?: MouseEventHandler<HTMLButtonElement>,
    label: string,
    width?: string,
    dataTestId?: string,
    variant?: 'text' | 'outlined' | 'contained' | undefined,
    color?: 'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning' | undefined,
    size?: 'small' | 'medium' | 'large' | undefined //because 'Theme' has paddings, size here is overridden
    type?: 'button' | 'submit' | 'reset' | undefined;
  }) => {
  return (
    <LoadingButton
      data-testid={dataTestId}
      loadingIndicator={loadingIndicator}
      size={size}
      disabled={disabled}
      loading={loading}
      loadingPosition={endIcon && !startIcon ? 'end' : !endIcon && startIcon ? 'start' : 'center'} //if there is no icon or both start & end icons, the spinner should be in the middle
      startIcon={startIcon}
      endIcon={endIcon}
      variant={variant || 'contained'}
      color={color}
      style={style}
      onClick={onClick}
      type={type || 'button'}
      sx={{
        width: width,
        boxShadow: 'none',
        '&:hover': {
          boxShadow: 'none'
        }
      }}
    >
      <FormattedMessage id={label} />
    </LoadingButton>
  );
};

export default AgLoadingButton;